<script>

  import defaultSort from './sort.js'
  import { createEventDispatcher } from 'svelte'
  import Icon from 'smelte/src/components/Icon'
  import Header from './Header.svelte'
  import FasIcon from 'fa-svelte'
  import Button from 'smelte/src/components/Button'
  import ProgressCircular from 'smelte/src/components/ProgressCircular'
  import { fade } from 'svelte/transition'
  import InfiniteScroll from './InfiniteScroll.svelte'
  import ComboBox from '../ComboBox.svelte'

  export let columns = []
  export let activationColumn = -1
  export let actions = []
  export let data = []
  export let dataPromise = null
  export let sort = defaultSort
  export let asc = true
  export let sortable = true
  export let sortBy = null
  export let filterable = true
  export let edit = false
  export let selectable = true
  export let headerClass = 'bg-gray-600'
  export let shrink = ''
  export let description = 'items'
  export let minWidth = 1024
  export let frameSize = 20
  export let filter = []
  export let current = data.length > 0 ? data[0].id : 0
  export let actionsLabel = 'Actions'

  const dispatch = createEventDispatcher()
  let page = 0
  let dropDown = ''
  let dropDownList = []

  $: sorted = doFilter(sort(data, sortBy, asc), filter)

  let visibleItems = []

  $: visibleItems = [...sorted].splice(0, frameSize * (page + 1) - 1)


  $: hasMore = frameSize * (page + 1) - 1 < sorted.length


  function rowSelectedHandler (l) {
    current = l.id
    dispatch('selected', l)
  }

  function keyupHandler (e, h) {
    if (e.key === 'Escape') {
      e.target.value = ''
      h.filter = ''
      filter = []
      return
    }
    filterChanged()
  }

  function filterChanged (h) {
    let tmp = []
    columns.forEach(h => {
      if (h.filter != null && h.filter !== '') {
        tmp.push({field: h.field, value: h.filter.toString().toLowerCase()})
      }
    })
    filter = tmp
  }

  function doFilter (collection, filter, begin, end) {
    if (!Array.isArray(filter)) {
      return [...collection]
    }
    let tmp = [...collection]
    filter.forEach(f => {
      tmp = [...tmp.filter(row => row[f.field] && row[f.field].toString().toLowerCase().indexOf(f.value) > -1)]
      //
      // SHOW ALL DOCUMENTS ANYWAY ?! EVEN IF SOME FIELDS ARE MISSING
      //
      // if (f.value && f.value !== '') {
      //   tmp = [...tmp.filter(row => row[f.field] && row[f.field].toString().toLowerCase().indexOf(f.value) > -1)]
      // }
    })
    tmp = tmp.slice(begin, end)

    dispatch('filtered', [...tmp])
    // visibleItems = []
    page = 0
    // console.log('[DEBUG] tmp', tmp.length)
    return tmp
  }

  function actionClickHandler (action, item) {
    dispatch('action', {action: action, item: item})
  }

  function scrollHandler (event) {
    console.log('[DEBUG] scrollHandler', event)
  }

  function filterClickHandler (column) {
    if (dropDown === column.field) {
      dropDown = null
      return
    }

    console.log('[DEBUG] dropDownList start:', new Date().getSeconds())
    const unique = {}
    const maxLen = 1000
    visibleItems.map(m => m[column.field]).forEach(v => {
      unique[v] = true
    })
    dropDownList = Object.keys(unique).slice(0, maxLen)
    dropDownList = dropDownList.length === maxLen ? [...dropDownList, '...'] : dropDownList

    dropDown = column.field
    console.log('[DEBUG] dropDownList finish:', new Date().getSeconds())
    console.log('[DEBUG] list', dropDownList)
  }

  function filterSelectedHandler (i, value) {
    console.log('[DEBUG] value', value)
    columns[i].filter = value
    filterChanged(columns[i])
    dropDown = null
  }

</script>

<div style="height: 500px; overflow-y: auto">
  <div class="flex flex-col relative" style={"min-width: " + minWidth + "px"}>
    <table class="relative w-full">

      <thead class="shadow sticky top-0">


      <tr class="relative z-10">
        {#each columns as h}
          <th class="z-20 text-left text-white font-normal hover:bg-gray-700 w-{h.w} {headerClass} {h.add}"
              style="border: 0">
            <slot name="header">
              <Header
                classes="py-3 px-3 text-left items-center justify-start"
                column={h}
                bind:asc bind:sortBy sortable={sortable} />
            </slot>
          </th>
        {/each}

        {#if actions.length > 0}
          <th class="sticky top-0 z-20 text-left text-white font-normal hover:bg-gray-700 w-20 {headerClass}">
            <div class="px-3">{actionsLabel}</div>
          </th>
        {/if}
      </tr>

      {#if filterable}
        <tr class="">
          {#each columns as h, i}
            <th class="relative w-{h.w} items-center pt-2 pb-2 px-1 bg-gray-100 {h.add}">
              <div class="pr-10 bg-white border-b {h.filterHide ? 'hidden':''}">
                <input type="text"
                       class="px-2 py-1 w-full"
                       placeholder={h.label}
                       bind:value={columns[i].filter}
                       on:keyup={(e) => keyupHandler(e, h)}

                >
                {#if h.filter != null && h.filter != ''}
                  <div class="cursor-pointer absolute text-gray-500 flex items-center select-none top-0 right-0
                          h-full flex items-center pr-8">
                    <Icon small
                          on:click={() => { h.filter = ''}}
                          on:click={(e) => keyupHandler(e, h)}
                    >clear
                    </Icon>
                  </div>
                {/if}

                <div
                  class="cursor-pointer h-full absolute top-0 right-0 pr-1 flex items-center select-none text-gray-500"
                  on:click={() => filterClickHandler(h)}>
                  <Icon>{dropDown === h.field ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</Icon>
                </div>

                {#if dropDown === h.field}
                  <div class="absolute w-full text-left text-gray-600 text-base font-normal elevation-3 bg-white
                          overflow-y-auto"
                       style="max-height: 10em"
                       on:click={() => dropDown = null}
                  >
                    {#each dropDownList as item}
                      <div class="leading-loose px-2 hover:bg-gray-200 overflow-x-hidden"
                           on:click={() => filterSelectedHandler(i, item)}>
                        {item}
                      </div>
                    {/each}
                  </div>
                {/if}

              </div>
            </th>
          {/each}
        </tr>
      {/if}

      </thead>

      <tbody>
      {#each visibleItems as l}
        <tr class="text-left border-b {edit ? 'border-gray-400' : 'border-gray-200'}"
            class:selectable={selectable === true}
            class:active={current === l.id && selectable}
            on:click={() => rowSelectedHandler(l)}
            on:dblclick={() => dispatch('dblclick', l)}
            in:fade
        >
          {#each columns as h, i}
            {#if edit}
              {#if !h.ro}
                <td class="w-{h.w} border-l {h.add} bg-gray-200 {edit ? 'border-gray-400' : 'border-gray-200'}">
                  {#if h.number}
                    <input type="number"
                           class="bg-gray-200 px-3 py-3 w-full"
                           bind:value={l[h.field]}
                    />
                  {:else if h.combo}
                    <ComboBox items={h.items} bind:value={l[h.field]} loading={false}
                              remove={'w-full left-0'} add={'md:w-1/4'} />
                  {:else}
                    <div class="flex">
                      <input type="text"
                             class="bg-gray-200 px-3 py-3 w-{h.w}"
                             bind:value={l[h.field]}
                      />
                      {#if h.suffixRef}
                        <div class="text-left py-3 px-1">{l[h.suffixRef]}</div>
                      {/if}
                    </div>
                  {/if}
                </td>
              {:else}
                <td class="w-{h.w} border-l {h.add}">
                  <div class="px-3 py-3">{l[h.field]}</div>
                </td>
              {/if}

            {:else}
              <td class="w-{h.w} px-3 py-3 {h.add}" style="border-right: 0">
                {#if i === activationColumn}
                  <div class="text-red-500 hover:underline link"
                       on:click={() => dispatch('dblclick', l)}>
                    {l[h.field]}
                  </div>
                {:else if h.currency != null}
                  <div class="text-right">
                    {l[h.field] == null || l[h.field] === 0 ? '' : l[h.field].toLocaleString() + ' ' + l[h.currency]}
                  </div>
                {:else if h.icon != null}
                  <div class="text-center w-full" style={`color: ${h.icon.color(l[h.field])}`}>
                    <div class="inline-block">
                      <FasIcon icon={h.icon.icon} />
                    </div>
                  </div>
                {:else}
                  <div class="flex">
                    <div class="w-{h.w}">{l[h.field]}</div>
                    {#if h.suffixRef}
                      <div class="text-left py-3 px-1">{l[h.suffixRef] ? l[h.suffixRef] : ''}</div>
                    {/if}
                  </div>
                {/if}
              </td>
            {/if}

          {/each}

          {#if actions && actions.length > 0}
            <td>
              <div class="px-6 flex items-center">
                {#each actions as a}
                  {#if a.rule == null || a.rule(l)  }
                    <div class="tooltip" on:click|stopPropagation={() => { actionClickHandler(a, l) } }>
                      <FasIcon icon={a.icon} class="text-xl mr-5 text-red-300" />
                      <!--                  <div class="text-white bg-red-500 text-base rounded px-2 py-1">-->
                      <!--                    P-->
                      <!--                  </div>-->
                      <div class="tooltip-text bg-white border border-gray-400 rounded
                              text-gray-600 py-1 px-2">
                        {a.hint}
                      </div>
                    </div>
                    <!--
                    <img src={'/static/img/' + a.icon} class="object-contain m-auto" style="max-height: 100%" />
                    -->
                  {/if}
                {/each}
              </div>
            </td>
          {/if}
        </tr>
      {/each}

      </tbody>

    </table>

    {#await dataPromise}
      <div class="flex flex-grow flex-col items-center justify-center w-full py-12">
        <div class="text-gray-400 text-lg font-light mb-4">Loading ...</div>
        <ProgressCircular color="red" />
      </div>
    {:then d}
      {#if visibleItems < 1}
        <div class="text-gray-400 text-xl font-light py-3">No {description} found</div>
      {/if}
    {/await}

    <!-- CSS fix, do not remove it -->
    <svg class="circular" style="width: 1px; height: 1px;">
      <circle
        class="path stroke-red"
        cx=1
        cy=1
        fill="none"
        r={1}
        stroke-width="1"
        stroke-miterlimit="1"
      />
    </svg>

  </div>
  <InfiniteScroll {hasMore} threshold={10} on:loadMore={() => page++} />

</div>

<style>
  .active {
    background-color: #fff3f5;
    overflow-x: visible;
    margin: 0 auto;
  }

  /*.tbody .selectable:hover {*/
  /*  background-color: #f4f4f4;*/
  /*}*/

  .tooltip {
    position: relative;
  }

  .tooltip .tooltip-text {
    display: none;
    text-align: center;
    padding: 6px 10px;
    position: absolute;
    top: -2em;
    left: -9em;
    z-index: 10;
    min-width: 100px;
  }

  .tooltip:hover .tooltip-text {
    display: block;
  }

  .link {

  }

  .link:hover {
    color: #810a22;
  }
</style>
